<teleport to="body">
  <div
    v-if="visible"
    class="modal fade show d-block"
    tabindex="-1"
    aria-modal="true"
    role="dialog"
  >
    <div class="modal-dialog modal-dialog-centered case-owner-profile-modal-dialog" @click.self="close_modal">
      <div class="modal-content bg-white rounded-4 p-0 shadow-lg overflow-hidden case-owner-profile-modal-content">
        <div class="case-owner-profile-modal-scroll">
          <div class="case-owner-profile-modal-header d-flex align-items-start justify-content-between gap-3">
            <div class="d-flex align-items-start gap-3">
              <div class="case-owner-profile-modal-avatar rounded-circle d-inline-flex align-items-center justify-content-center fw-bold flex-shrink-0">
                {{ profile.initials }}
              </div>
              <div class="min-w-0">
                <div class="case-owner-profile-modal-name text-truncate">{{ profile.name }}</div>
                <div class="case-owner-profile-modal-meta text-uppercase">
                  {{ profile.role_label }} <span class="mx-1">.</span> {{ profile.scope_label }} <span class="mx-1">.</span> {{ profile.panel_id }}
                </div>
              </div>
            </div>

            <button
              type="button"
              class="btn-close modal-btn-close case-owner-profile-modal-close"
              aria-label="Close"
              @click="close_modal"
            ></button>
          </div>

          <div class="case-owner-profile-modal-body">
            <section class="row g-3 mb-4">
              <div v-for="metric in metric_cards" :key="metric.label" class="col-12 col-sm-6 col-xl-3">
                <article class="case-owner-profile-stat-card rounded-4 h-100">
                  <div class="case-owner-profile-stat-label text-uppercase">{{ metric.label }}</div>
                  <div class="case-owner-profile-stat-value">{{ metric.value }}</div>
                  <div class="case-owner-profile-stat-detail">{{ metric.detail }}</div>
                </article>
              </div>
            </section>

            <section class="row g-4 mb-4">
              <div class="col-12 col-lg-5">
                <div class="case-owner-profile-section-title text-uppercase mb-3">Contact & Assignment</div>
                <div class="d-flex flex-column gap-3">
                  <div
                    v-for="row in contact_rows"
                    :key="row.label"
                    class="row g-3"
                  >
                    <div class="col-5">
                      <div class="case-owner-profile-label">{{ row.label }}</div>
                    </div>
                    <div class="col-7">
                      <div class="case-owner-profile-value">{{ row.value }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-lg-7">
                <div class="case-owner-profile-section-title text-uppercase mb-3">Accreditation & Specialism</div>
                <div class="d-flex flex-wrap gap-2 mb-3">
                  <span
                    v-for="tag in specialties"
                    :key="tag.label"
                    class="badge rounded-pill fw-normal case-owner-profile-pill"
                    :class="tag.badge_class"
                  >
                    {{ tag.label }}
                  </span>
                </div>

                <div class="d-flex flex-column gap-2 case-owner-profile-rich-copy">
                  <div><strong>Authorisation cap:</strong> {{ profile.authorisation_cap }}</div>
                  <div><strong>FAIS:</strong> {{ profile.fais }}</div>
                  <div><strong>CPD:</strong> {{ profile.cpd }}</div>
                </div>
              </div>
            </section>

            <section class="border-top pt-4">
              <div class="case-owner-profile-section-title text-uppercase mb-3">My onboarding(s) - current snapshot</div>
              <div class="row g-3">
                <div v-for="item in case_snapshot" :key="item.label" class="col-6 col-lg">
                  <article class="case-owner-profile-snapshot-card rounded-3 h-100" :class="item.border_class">
                    <div class="case-owner-profile-snapshot-value">{{ item.value }}</div>
                    <div class="case-owner-profile-snapshot-label text-uppercase">{{ item.label }}</div>
                  </article>
                </div>
              </div>
            </section>
          </div>
        </div>

        <div class="case-owner-profile-modal-footer d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-outline-secondary btn-sm rounded-small px-4" @click="close_modal">
            Close
          </button>
          <button type="button" class="btn btn-primary-dark btn-sm rounded-small px-4" @click="edit_profile">
            Edit profile
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="visible" class="modal-backdrop fade show case-owner-profile-modal-backdrop" @click="close_modal"></div>
</teleport>
